var plugin_rtlignore_default = {
  "alignLeft": "VHXrg",
  "textWrapNowrap": "IcIaH",
  "alignRight": "mk-sk",
  "alignCenter": "kuhYN",
  "sizeFullWidth": "_253AZ",
  "renderedInTable": "_4-3Ct",
  "sizeOriginal": "_8ljLV",
  "sizeContent": "QPsLN",
  "sizeSmall": "yYs6t",
  "sizeSmallCenter": "BH2v1",
  "flex": "Uk7Cc",
  "atomic": "irodq",
  "embed": "elN-m",
  "horizontalScrollbar": "IftTp",
  "pluginContainerMobile": "wC1zk"
};
export {
  plugin_rtlignore_default as default
};
//# sourceMappingURL=plugin.rtlignore-scss.js.map
